import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { Megaphone, Send } from 'lucide-react';
import { api } from '../../lib/api';
import { SectionHead } from '../../components/ui';

export default function AdminBroadcast() {
  const [f, setF] = useState({ title: '', body: '', link: '', target: 'all' });
  const send = useMutation({
    mutationFn: () => api.post('/admin/broadcast', f),
    onSuccess: ({ data }) => { toast.success(`Sent to ${data.sent} users 📢`); setF({ title: '', body: '', link: '', target: 'all' }); },
    onError: e => toast.error(e.message),
  });

  return (
    <div className="card p-5 max-w-lg">
      <SectionHead title="Broadcast notification" sub="Delivered instantly to 100% of the audience" />
      <div className="space-y-3">
        <div>
          <label className="label">Audience</label>
          <div className="grid grid-cols-3 gap-2">
            {[['all', '🌍 Everyone'], ['users', '🦸 Shoppers'], ['producers', '🏪 Producers']].map(([k, l]) => (
              <button key={k} onClick={() => setF({ ...f, target: k })}
                className={`py-2 rounded-xl text-xs font-bold border-2 transition
                  ${f.target === k ? 'border-brand-500 bg-brand-50 text-brand-700' : 'border-ink-200 text-ink-500'}`}>{l}</button>))}
          </div>
        </div>
        <div><label className="label">Title *</label>
          <input className="input" value={f.title} maxLength={160}
            onChange={e => setF({ ...f, title: e.target.value })} placeholder="🔥 Double points weekend!" /></div>
        <div><label className="label">Message</label>
          <textarea className="input min-h-[90px]" value={f.body} maxLength={500}
            onChange={e => setF({ ...f, body: e.target.value })} /></div>
        <div><label className="label">Link (optional)</label>
          <input className="input" value={f.link} onChange={e => setF({ ...f, link: e.target.value })} placeholder="/shops" /></div>
        <button onClick={() => confirm('Send to everyone?') && send.mutate()} disabled={send.isPending || !f.title}
          className="btn-primary w-full py-3">
          {send.isPending ? 'Sending…' : <><Send size={15} /> Send broadcast</>}
        </button>
      </div>
    </div>
  );
}